import postsReducer from './';

export default postsReducer;
